import { useNavigate } from 'react-router-dom';

export const SuccessMessage = ({ email, onReturnClick }) => {
  const navigate = useNavigate();

  const handleReturn = () => {
    if (onReturnClick) {
      onReturnClick();
    } else {
      navigate('/');
    }
  };

  return (
    <div className="flex w-full flex-col items-center gap-6 rounded-3xl bg-white p-8 text-center shadow-xl ring-1 ring-[#00a389]/20">
      <h2 className="text-2xl font-bold text-[#008f78]">Email envoyé !</h2>
      <p className="text-gray-600">
        Un email de réinitialisation de mot de passe a été envoyé à <strong>{email}</strong>.
        Consultez votre boîte de réception et suivez les instructions.
      </p>
      <button
        onClick={handleReturn}
        className="w-full rounded-full bg-[#00a389] py-3.5 text-base font-semibold text-white shadow-[0_12px_24px_rgba(0,163,137,0.25)] transition hover:bg-[#00967d]"
      >
        Retour à la connexion
      </button>
    </div>
  );
};
